import React, {PureComponent} from 'react';
import './App.css';
import CollapseMaster from './components/CollapseMaster/CollapseMaster';

class App extends PureComponent {

  render() {
    const {items, title} = this.props;
    return (
      <div className='App' >
        <div className='test'>
          <CollapseMaster
            title={title}
            items={items}
          />
        </div>
        <div style={{height: 350}}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js